// src/pages/usa/colorado/Colorado.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackSearchGo from "../../../components/BackSearchGo";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Colorado() {
  const navigate = useNavigate();

  // ⭐ Popup state — required for opening/closing the popup
  const [open, setOpen] = useState(false);

  // ⭐ Colorado places — alphabetical, only Aspen visited
  const places = [
  { name: "Aspen", visited: true, page: "/travel/usa/colorado/aspen" },

  { name: "Buena Vista", visited: true, page: "/travel/usa/colorado/buenavista" },
  { name: "Breckenridge", visited: true, page: "/travel/usa/colorado/breckenridge" },
  { name: "Canyon City", visited: true, page: "/travel/usa/colorado/canyoncity" },
  { name: "Colorado Springs", visited: true, page: "/travel/usa/colorado/coloradosprings" },
  { name: "Denver", visited: true, page: "/travel/usa/colorado/denver" },
  { name: "Frisco", visited: true, page: "/travel/usa/colorado/frisco" },

  { name: "Fruita", visited: true, page: "/travel/usa/colorado/fruita" },

  { name: "Georgetown", visited: true, page: "/travel/usa/colorado/georgetown" },
  { name: "Glenwood Springs", visited: true, page: "/travel/usa/colorado/glenwoodsprings" },
  { name: "Golden", visited: true, page: "/travel/usa/colorado/golden" },
  { name: "Idaho Springs", visited: true, page: "/travel/usa/colorado/idahosprings" },

  { name: "Lake City", visited: false },
  { name: "Larkspur", visited: false },
  { name: "Leadville", visited: false },

  { name: "Manitou", visited: true, page: "/travel/usa/colorado/manitousprings" },
  { name: "Morrison", visited: true, page: "/travel/usa/colorado/morrison" },
  { name: "Mosca", visited: true, page: "/travel/usa/colorado/mosca" },
  { name: "Ouray", visited: true, page: "/travel/usa/colorado/ouray" },
  { name: "Rifle", visited: true, page: "/travel/usa/colorado/rifle" },
  { name: "Steamboat", visited: true, page: "/travel/usa/colorado/steamboat" },
  { name: "Telluride", visited: true, page: "/travel/usa/colorado/telluride" },
  { name: "Vail", visited: true, page: "/travel/usa/colorado/vail" },

  { name: "Yampa", visited: false },
];


  return (
    <>
      <Header />

      <div
        className="usa-container colorado-page"
        style={{
          backgroundImage: "url('/images/usa/colorado/Colorado.png')",
          backgroundSize: "90%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          paddingTop: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >

        {/* ⭐ Back / Search / Go — wrapped for top positioning */}
        <div className="searchbar-top-container">
          <BackSearchGo onBack={() => navigate("/map/usa")} />
        </div>

        {/* ⭐ Legend */}
        <div className="legend" style={{ marginBottom: "20px" }}>
          <span className="legend-blue">Blue = Visited Places</span>
          <span className="legend-green">Green = Places To Visit</span>
        </div>


        {/* ⭐ 3‑column grid */}
        <div className="colorado-grid-3">
          {places.map((p) => (
            <div
              key={p.name}
              className={`place ${p.visited ? "visited" : "to-visit"}`}
              onClick={() => p.visited && navigate(p.page)}
              style={{ cursor: p.visited ? "pointer" : "default" }}
            >
              {p.name}
            </div>
          ))}
        </div>
      </div>

      {/* Centered email button */}
      <div className="email-wrapper">
        <button
          className="email-link"
          onClick={() => setOpen(true)}
        >
          contact@thefindingspot.com
        </button>
      </div>

      {/* Popup */}
      <ContactPopup
        isOpen={open}
        onClose={() => setOpen(false)}
      />

      <Footer />
    </>
  );
}
